import React, { FC, useEffect, useRef } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  TourCardV2,
  NoAvailableData,
} from 'views/rebranded-module/common/components';
import PATHS from 'lib/navigation/paths';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';

const ToursListingSection: FC<any> = (props) => {
  const { filteredTours } = props;
  const resetBtnContainerRef = useRef(null);
  const cmsData = useContent();
  const appNavigator = useAppNavigator();
  const handleResetClick = () => {
    sessionStorage.removeItem('duration');
    appNavigator.push(PATHS.motorcycleTours.listing());
  };
  useEffect(() => {
    const buttonEl = resetBtnContainerRef.current?.querySelector('.TLResetBtn');
    if (buttonEl) {
      buttonEl.onclick = handleResetClick;
    }
  }, [filteredTours]);
  return (
    <Box mt={2}>
      {filteredTours.length > 0 ? (
        <Grid container rowSpacing={4} columnSpacing={2}>
          {filteredTours.map((tour: any) => (
            <Grid item xxl={2.4} xl={3} lg={4} md={6} sm={12} key={tour.name}>
              <TourCardV2 showPricingTermsTooltip tour={tour} content={cmsData.TourCardComponent} showStartEndCity showTagLine showCarousel />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box py={16}>
          <NoAvailableData title={cmsData.ToursListingPage.noToursAvailable}>
            <Box ref={resetBtnContainerRef}>
              <Typography
                variant="body3"
                color="text.secondary"
                dangerouslySetInnerHTML={{
                  __html: cmsData.ToursListingPage.noToursAvailableDescription,
                }}
              />
            </Box>
          </NoAvailableData>
        </Box>
      )}
    </Box>
  );
};

export { ToursListingSection };
